






























































































import { Component, Vue } from 'vue-property-decorator';
import { stAccountApi } from '@/services/st-api';
import { notifySuccess } from '@/utlitities/notifications';
import { AccountAdvEditModel } from '@/services/api/nswag/stapiclient_generated';
//@ts-ignore
import * as FileSaver from 'file-saver';
import StSettingsSeparator from '@/components/basic/Form/StSettingsSeparator.vue';

@Component({
  components: {StSettingsSeparator},
})
export default class AccountSettingsPrivacy extends Vue {
  loading: boolean = false;
  editModel: AccountAdvEditModel = AccountAdvEditModel.fromJS({});

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    this.editModel = await stAccountApi.getAdvEditModel();
  }

  async downloadPdf() {
    this.loading = true;
    let fileData = await stAccountApi.getAdvContractPdf();
    FileSaver.saveAs(fileData.data, fileData.fileName);
    this.loading = false;
  }

  async storeAdv() {
    try {
      this.loading = true;
      await stAccountApi.saveAdvData(this.editModel);
      await this.loadData();
      notifySuccess('Gespeichert');
    } finally {
      this.loading = false;
    }
  }
}
